import { Box, Flex, Text } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import React from "react";
import { AuthorizationModel, bindProperty, ACCOUNT_TYPES } from "@lubbezposrednio-frontend/core";

interface RadioButtonsSectionProps {
  authorization: AuthorizationModel;
}

const OPTIONS = [
  { value: ACCOUNT_TYPES.PERSON, title: "Osoba fizyczna" },
  { value: ACCOUNT_TYPES.ORGANIZATION, title: "Organizacja" }
];

export const RadioButtonsSection: React.FC<RadioButtonsSectionProps> = observer(({ authorization }) => {
  const { value, onChange } = bindProperty(authorization, "accountType");

  return (
    <Box w="100%">
      <Text fontSize="13.5px" fontWeight="600" color="primary" mb="6px" pl="2px">
        Typ konta
      </Text>
      <Flex border="1.5px solid" borderColor="rgba(67,0,152,0.16)" borderRadius="12px" p="3px" gap="3px" bg="white">
        {OPTIONS.map(o => {
          const selected = value === o.value;
          return (
            <Box
              as="button"
              type="button"
              key={o.value}
              flex="1"
              onClick={() => onChange(o.value)}
              py="9px"
              borderRadius="9px"
              fontSize="14px"
              fontWeight="700"
              bg={selected ? "primary" : "transparent"}
              color={selected ? "white" : "gray.500"}
              transition="all 0.15s"
              _hover={selected ? {} : { color: "primary", bg: "rgba(67,0,152,0.05)" }}
            >
              {o.title}
            </Box>
          );
        })}
      </Flex>
    </Box>
  );
});
